var exports = {
  "HT": "xf0b3b88a--6fe66e--like-button",
  "l$": "xf0b3b88a--6fe66e--more-popup",
  "fK": "xf0b3b88a--6fe66e--more-list",
  "M3": "xf0b3b88a--6fe66e--more-item",
  "Rr": "xf0b3b88a--6fe66e--more-link",
  "_C": "xf0b3b88a--6fe66e--like-container",
  "uV": "xf0b3b88a--6fe66e--delimiter",
};

module.exports = exports;
